/**
 * SayfaBoyutuSecici.jsx — "Sayfa başına: 10 · 25 · 50 · 100" seçici (#728).
 *
 * Kişi Listesi ile Firma Detay › Personel Listesi'nin ortak sayfa boyutu seçicisi. Değer adres çubuğunda `boyut` olarak tutulur (kişi
 * detayından dönüşte sayfa numarasıyla birlikte yerinde kalsın); tanınmayan değer sessizce varsayılana (10) düşer (sayfaBoyutu.js).
 */
import React from "react";
import { Input } from "reactstrap";
import { useTranslation } from "react-i18next";
import { SAYFA_BOYUTLARI, sayfaBoyutuCozumle } from "./sayfaBoyutu";

export default function SayfaBoyutuSecici({ value, onChange, disabled = false, className = "" }) {
  const { t } = useTranslation("yonetim");
  return (
    <label className={`d-inline-flex align-items-center gap-2 mb-0 small text-muted ${className}`.trim()} title={t("sayfaBoyutuSecici.ipucu")}>
      {t("sayfaBoyutuSecici.etiket")}
      <Input
        type="select" bsSize="sm" style={{ width: 76 }} value={value} disabled={disabled}
        aria-label={t("sayfaBoyutuSecici.etiket")} data-testid="sayfa-boyutu"
        onChange={(e) => onChange(sayfaBoyutuCozumle(e.target.value))}
      >
        {SAYFA_BOYUTLARI.map((n) => <option key={n} value={n}>{n}</option>)}
      </Input>
    </label>
  );
}
